import { poolSettings, reelsSettings, spinSettings } from 'settings/custom/reels'

import { getSymbol } from '../baseSymbol/SymbolFactory'

export  class BasePool {
  constructor() {
    this.reelsSettings = reelsSettings
    this.spinSettings = spinSettings
    this.poolSettings = poolSettings
    this.poolSymbols = {}
    this.createSymbols()
  }
  createSymbols(){
    const items = game.models.SpinModel.get().reelSymbols
    items.forEach((id) => {
      const symbols = []
      for (let i = 0; i <= this.poolSettings.symbolCount; i++) {
        const symbol = getSymbol(id, this.reelsSettings )
        symbol.renderable = false
        symbols.push(symbol)
      }
      this.poolSymbols[id] = symbols
    })
  }

  getSymbols(id){
    return this.poolSymbols[id].pop()
  }

  returnSymbols(symbol){

    symbol.renderable = false
    this.poolSymbols[symbol.id].push(symbol)
  }

}
